export class PaginationViewModel {
    pageSize: number = 0;
    pageIndex: number = 0;
    OfficeIDList:Array<number>=[]
    //SearchKey:"";
}
